import { FolderPlus, ListVideo, Plus, Settings2, Tags } from 'lucide-react';

/**
 * admin専用ページの機能一覧。
 * AdminIndex のカード表示と、各機能ページのヘッダー（タイトル・説明）の両方から参照する。
 * 機能を追加するときはここに1件足して、`page` と同名のページを pages.config.js に登録する。
 */
export const ADMIN_FEATURES = [
  {
    page: 'AdminVideoIndex',
    label: '動画一覧',
    description: '登録済みの動画を確認し、タイトル・タグ・公開状態・表示順を編集します。',
    icon: ListVideo,
    isAvailable: true,
  },
  {
    page: 'AdminVideoCreate',
    label: '新規追加',
    description: '動画・サムネイル・配布資料をアップロードして動画を登録します。',
    icon: Plus,
    isAvailable: true,
  },
  {
    page: 'AdminVideoTagSettings',
    label: 'タグ付与・設定変更',
    description: 'カテゴリなど、動画一覧から扱わない設定変更を行います。',
    icon: Settings2,
    isAvailable: false,
  },
  {
    page: 'AdminTagEdit',
    label: 'タグ追加・編集',
    description: 'タグマスタ（tags テーブル）の追加・編集を行います。',
    icon: Tags,
    isAvailable: false,
  },
  {
    page: 'AdminCategoryCreate',
    label: 'カテゴリ追加',
    description: 'カテゴリマスタ（categories テーブル）に新しいカテゴリを追加します。',
    icon: FolderPlus,
    isAvailable: false,
  },
];

export function getAdminFeature(page) {
  return ADMIN_FEATURES.find((feature) => feature.page === page) ?? null;
}
